import { Component, HostListener, Input } from '@angular/core';
import { Result } from './result';
import { ResultsMetaService } from '../results-meta/results-meta.service';

@Component({
  selector: 'mc-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.scss']
})
export class ResultComponent {

  @Input() result: Result;

  @HostListener('mouseover') hover() {
    this.resultsMetaService.hover(this.result);
  }

  @HostListener('mouseout') unhover() {
    this.resultsMetaService.unhover(this.result);
  }

  constructor(private resultsMetaService: ResultsMetaService) {
  }

  isHovered() {
    return this.resultsMetaService.isHovered(this.result);
  }

  getDuplicates() {
    return this.resultsMetaService.get(this.result).duplicates;
  }
}
